import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMobizHttpService, SerializableObjectList } from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';

import { CityPostalCode } from '../data/city-postal-code.do';
import { Country } from '../data/country.do';
import { PosturinnApiEndpointConfiguration } from '../other/api-endpoint-configuration.interface';
import { PosturinnServerApi } from '../other/posturinn-server-api.enum';

export interface IAddressService {
  /** Returns a list of Icelandic postal codes. */
  getCityPostalCodes(): Observable<CityPostalCode[]>;

  /** Returns a list of countries and their availability. */
  getCountries(): Observable<Country[]>;
}

export const IAddressService: InjectionToken<IAddressService>
  = new InjectionToken<IAddressService>('IAddressService');

@Injectable()
export class AddressService implements IAddressService {
  constructor(
    @Inject(IMobizHttpService)
    private readonly httpService: IMobizHttpService,
  ) {
  }

  public getCityPostalCodes(): Observable<CityPostalCode[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.PostalCodes,
    };
    const list: SerializableObjectList<CityPostalCode> = new SerializableObjectList(CityPostalCode);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<CityPostalCode>): CityPostalCode[] => {
        return response.items ? response.items : [];
      }),
    );
  }

  public getCountries(): Observable<Country[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.Countries,
    };
    const list: SerializableObjectList<Country> = new SerializableObjectList(Country);
    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<Country>): Country[] => {
        return response.items ? response.items : [];
      }),
    );
  }

}
